import React, { useEffect,  useState } from 'react'
import { useLocation } from 'react-router-dom';
import { useStateValue } from '../../../StateProvider';
import { getDefaultValue, sortByKey } from '../../../utils';
import { loadCountries, loadProfile, saveProfile } from '../../../utils/Network';
import SelectCities from '../../select/SelectCities';
import SelectGender from '../../select/SelectGender';
import SelectCountries from "../../select/SelectCountries";
import SelectDate from '../../select/SelectDate';

function ProfileForm(props) {
    const [user, setUser] = useState([]);
    const [loading, setLoading] = useState(false);
    const [countries, setCountries] = useState(null);
    const [birth_date, setBirthDate] = useState(null);
    
    const location = useLocation();
    const [country, setCountry] = useState(null);
    const [city, setCity] = useState(null);
    const [livingcountry, setLivingCountry] = useState(null);
    const [livingcity, setLivingCity] = useState(null);
    const [gender, setGender] = useState(null);

    const [{ translations }] = useStateValue();
    const translate = (str) => {
        if (!translations) return str;
        var translate = translations.find(x => x.key == str);

        if (translate) return getDefaultValue(translate);
        else return "#" + str;
    };

    useEffect(() => {
        setLoading(true);
        loadProfile().then((profile) => {
            setUser(profile);
            setLoading(false);
            if (profile) {
                if (profile.role === "normal") {
                    window.location.href = "/talent/6"
                }

                if (profile.birth_date) {
                    setBirthDate(profile.birth_date)
                }
                if (profile.country_id != null && profile.country_id !== '') {
                    const cid = profile.country_id;
                    setCountry(typeof cid === 'number' ? cid : (Number.isFinite(Number(cid)) ? Number(cid) : cid));
                }
                if (profile.city_id != null && profile.city_id !== '') {
                    const tid = profile.city_id;
                    setCity(typeof tid === 'number' ? tid : (Number.isFinite(Number(tid)) ? Number(tid) : tid));
                }
                if (profile.livingcountry_id != null && profile.livingcountry_id !== '') {
                    const lid = profile.livingcountry_id;
                    setLivingCountry(typeof lid === 'number' ? lid : (Number.isFinite(Number(lid)) ? Number(lid) : lid));
                }
                if (profile.livingcity_id != null && profile.livingcity_id !== '') {
                    const lid = profile.livingcity_id;
                    setLivingCity(typeof lid === 'number' ? lid : (Number.isFinite(Number(lid)) ? Number(lid) : lid));
                }
                if (profile.gender > -1) {
                    setGender(profile.gender);
                }

            }
        });
        loadCountries(1, 10000).then((countries) => {
            sortByKey(countries);
            setCountries(countries);
        });
    }, []);


    const onValue = (name, value) => {
        switch (name) {
            case "birth_date":
                setUser((prev) => ({ ...(prev || {}), birth_date: value }));
                setBirthDate(value);
                break;
            case "gender":
                setGender(value);
                break;
            case "country":
                setCountry(value);
                setCity(null);
                setUser((prev) => ({
                    ...(prev || {}),
                    country_id: value,
                    city_id: null,
                }));
                break;
            case "city":
                setCity(value);
                setUser((prev) => ({ ...(prev || {}), city_id: value }));
                break;
            case "living_country":
                setLivingCountry(value);
                setLivingCity(null);
                setUser((prev) => ({
                    ...(prev || {}),
                    livingcountry_id: value,
                    livingcity_id: null,
                }));
                break;
            case "living_city":
                setLivingCity(value);
                setUser((prev) => ({ ...(prev || {}), livingcity_id: value }));
                break;
            default:
                break;
        }
    };


    const handleOnChange = (e) => {
        const el = e.target;
        switch (el.name) {
            case "first_name":
                setUser((prev) => ({ ...(prev || {}), first_name: el.value }));
                break;
            case "last_name":
                setUser((prev) => ({ ...(prev || {}), last_name: el.value }));
                break;
            case "gender":
                setGender(el.value);
                break;
            case "phone_number":
                setUser((prev) => ({ ...(prev || {}), phone_number: el.value }));
                break;

            case "password":
                setUser((prev) => ({ ...(prev || {}), password: el.value }));
                break;
            case "confirmpassword":
                setUser((prev) => ({ ...(prev || {}), confirmpassword: el.value }));
                break;
            case "website":
                setUser((prev) => ({ ...(prev || {}), website: el.value }));
                break;
            case "facebook":
                setUser((prev) => ({ ...(prev || {}), facebook: el.value }));
                break;
            case "instagram":
                setUser((prev) => ({ ...(prev || {}), instagram: el.value }));
                break;
            case "youtube":
                setUser((prev) => ({ ...(prev || {}), youtube: el.value }));
                break;
            case "snapchat":
                setUser((prev) => ({ ...(prev || {}), snapchat: el.value }));
                break;
            case "spotify":
                setUser((prev) => ({ ...(prev || {}), spotify: el.value }));
                break;
            case "comments":
                setUser((prev) => ({ ...(prev || {}), comments: el.value }));
                break;

            default:
                break;
        }
    };

    const saveChanges = (e) => {
        setLoading(true);
        const temp = {
            ...(user || {}),
            gender,
            country_id: country,
            city_id: city,
            livingcountry_id: livingcountry,
            livingcity_id: livingcity,
        };

        saveProfile(temp).then((data) => {
            console.log(data);
            if(data.id){
                if(props.onSuccess){
                    props.onSuccess()
                }
            }
            setLoading(false);
        });
    };

    return (
        <>
            <form className="needs-validation styled">
                <div className="row">
                    <div className="col-md-6 mb-2">
                                <input
                                    className="form-control text-3 h-auto py-2 rounded-35"
                                    type="text"
                                    name="first_name"
                                    defaultValue={user && user.first_name}
                                    onChange={handleOnChange}
                                    placeholder={translate("Name")}
                                />
                    </div>
                    <div className="col-md-6 mb-2">
                                <input
                                    className="form-control text-3 h-auto py-2 rounded-35"
                                    type="text"
                                    name="last_name"
                                    defaultValue={user && user.last_name}
                                    onChange={handleOnChange}
                                    placeholder={translate("Surename")}
                                />
                            </div>
                </div>

                <div className="row">
                    <div className="col-lg-3 mb-3">
                        <SelectGender
                            placeholder={translate("Gender")}
                            value={gender}
                            callback={onValue}
                        />
                    </div>
                    <div className="col-lg-9">
                        <input
                            className="form-control text-3 h-auto py-2 rounded-35"
                            type="phone"
                            name="phone_number"
                            onChange={handleOnChange}
                            defaultValue={user && user.phone_number}
                            placeholder={translate("Phone Number")}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    {/* <label className="col-lg-12 lan-text-right px-3">
                        {translate("Date of Birth")}
                    </label> */}
                    <div className="form-group col-lg-12">
                        <SelectDate value={birth_date} label={translate("Date of Birth")}  onDatePicked={onValue} />
                    </div>
                    {/* <div className="form-group col-lg-4">
                        <div className="custom-select-1">
                            <SelectYear
                                placeholder={translate("Year")}
                                name="birth_year"
                                width="100"
                                value={birth_year}
                                callback={onValue}
                            />
                        </div>
                    </div>
                    <div className="form-group col-lg-4">
                        <div className="custom-select-1">
                            <SelectMonth
                                placeholder={translate("Month")}
                                name="month"
                                width="100"
                                value={birth_month}
                                callback={onValue}
                            />
                        </div>
                    </div>
                    <div className="form-group col-lg-4">
                        <div className="custom-select-1">
                            <SelectDay
                                placeholder={translate("Day")}
                                name="day"
                                width="100"
                                value={birth_day}
                                callback={onValue}
                            />
                        </div>
                    </div> */}
                </div>

                <label className="lan-text-right full-width">
                    {translate("I am originally from")}
                </label>
                <div className=" row">
                    <div className="col-lg-6 mb-2">
                        <SelectCountries
                            placeholder={translate("Countries")}
                            kurds={1}
                            callback={(_n, v) => onValue("country", v)}
                            value={country}
                            name="country"
                        />
                    </div>
                    <div className="col-lg-6">
                        <SelectCities
                            placeholder={translate("City")}
                            key={country}
                            country={country}
                            name="city"
                            value={city}
                            callback={(_n, v) => onValue("city", v)}
                        />
                    </div>
                </div>
                <label className="lan-text-right full-width mt-2">
                    {translate("I am living in")}
                </label>
                <div className="form-group row">
                    <div className="col-lg-6 mb-3">
                        <SelectCountries
                            placeholder={translate("Countries")}
                            kurdsOnTop={1}
                            callback={(_n, v) => onValue("living_country", v)}
                            value={livingcountry}
                            name="living_country"
                        />
                    </div>
                    <div className="col-lg-6">
                        <SelectCities
                            placeholder={translate("Living City")}
                            key={livingcountry}
                            country={livingcountry}
                            value={livingcity}
                            name="living_city"
                            callback={(_n, v) => onValue("living_city", v)}
                        />
                    </div>
                </div>

                <div className=" row">
                    <div className=" col-lg-12">
                    <input
                            type="button"
                            value={translate("Close")}
                            className="btn rounded-35 color-white float-left lan-float-right kfont"
                            onClick={()=>{ if(props.onCancel) props.onCancel(); }}
                        />
                        <input
                            type="button"
                            value={translate("Save Changes")}
                            className="btn rounded-35 btn-rash btn-modern float-right lan-float-left"
                            disabled={loading}
                            onClick={saveChanges}
                        />
                    </div>
                </div>
            </form>
            {loading && (
                <div className="alert alert-primary">Please Wait...</div>
            )}
        </>
    )
}

export default ProfileForm